import { useMemo } from 'react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { MessageDescriptor } from '@lingui/core'

export const COUNTRY_TO_VAT_NAME: Record<string, MessageDescriptor> = {
  // EU Countries
  AT: msg`VAT Identification Number`,
  BE: msg`VAT Identification Number`,
  BG: msg`VAT Identification Number`,
  HR: msg`VAT Identification Number`,
  CY: msg`VAT Identification Number`,
  CZ: msg`VAT Identification Number`,
  DK: msg`VAT Identification Number`,
  EE: msg`VAT Identification Number`,
  FI: msg`VAT Identification Number`,
  FR: msg`VAT Identification Number`,
  DE: msg`VAT Identification Number`,
  GR: msg`VAT Identification Number`,
  HU: msg`VAT Identification Number`,
  IE: msg`VAT Identification Number`,
  IT: msg`VAT Identification Number`,
  LV: msg`VAT Identification Number`,
  LT: msg`VAT Identification Number`,
  LU: msg`VAT Identification Number`,
  MT: msg`VAT Identification Number`,
  NL: msg`VAT Identification Number`,
  PL: msg`VAT Identification Number`,
  PT: msg`VAT Identification Number`,
  RO: msg`VAT Identification Number`,
  SK: msg`VAT Identification Number`,
  SI: msg`VAT Identification Number`,
  ES: msg`VAT Identification Number`,
  SE: msg`VAT Identification Number`,

  // Non-EU Countries
  AU: msg`ABN (Australian Business Number)`,
  AE: msg`TRN (Tax Registration Number)`,
  CH: msg`VAT Identification Number`,
  GB: msg`VAT Identification Number`,
  JP: msg`JCT Registration Number`,
  KR: msg`Business Registration Number`,
  NO: msg`VAT Identification Number`,
  NZ: msg`GST Number`,
  SG: msg`GST Registration Number`,
  TH: msg`VAT Registration Number`
}

export function useSupportedCountries() {
  const { t } = useLingui()

  return useMemo(() => {
    return [
      // EU Countries
      {
        label: t`Austria`,
        value: 'AT'
      },
      {
        label: t`Belgium`,
        value: 'BE'
      },
      {
        label: t`Bulgaria`,
        value: 'BG'
      },
      {
        label: t`Croatia`,
        value: 'HR'
      },
      {
        label: t`Cyprus`,
        value: 'CY'
      },
      {
        label: t`Czechia`,
        value: 'CZ'
      },
      {
        label: t`Denmark`,
        value: 'DK'
      },
      {
        label: t`Estonia`,
        value: 'EE'
      },
      {
        label: t`Finland`,
        value: 'FI'
      },
      {
        label: t`France`,
        value: 'FR'
      },
      {
        label: t`Germany`,
        value: 'DE'
      },
      {
        label: t`Greece`,
        value: 'GR'
      },
      {
        label: t`Hungary`,
        value: 'HU'
      },
      {
        label: t`Ireland`,
        value: 'IE'
      },
      {
        label: t`Italy`,
        value: 'IT'
      },
      {
        label: t`Latvia`,
        value: 'LV'
      },
      {
        label: t`Lithuania`,
        value: 'LT'
      },
      {
        label: t`Luxembourg`,
        value: 'LU'
      },
      {
        label: t`Malta`,
        value: 'MT'
      },
      {
        label: t`Netherlands`,
        value: 'NL'
      },
      {
        label: t`Poland`,
        value: 'PL'
      },
      {
        label: t`Portugal`,
        value: 'PT'
      },
      {
        label: t`Romania`,
        value: 'RO'
      },
      {
        label: t`Slovakia`,
        value: 'SK'
      },
      {
        label: t`Slovenia`,
        value: 'SI'
      },
      {
        label: t`Spain`,
        value: 'ES'
      },
      {
        label: t`Sweden`,
        value: 'SE'
      },

      // Other Countries with reverse charge
      {
        label: t`Thailand`,
        value: 'TH'
      },
      {
        label: t`Australia`,
        value: 'AU'
      },
      {
        label: t`Singapore`,
        value: 'SG'
      },
      {
        label: t`Switzerland`,
        value: 'CH'
      },
      {
        label: t`United Kingdom`,
        value: 'GB'
      },
      {
        label: t`New Zealand`,
        value: 'NZ'
      },
      {
        label: t`Norway`,
        value: 'NO'
      },
      {
        label: t`Japan`,
        value: 'JP'
      },
      {
        label: t`United Arab Emirates`,
        value: 'AE'
      },
      {
        label: t`South Korea`,
        value: 'KR'
      }

      // Not sure
      // {
      //   label: t`Canada`,
      //   value: 'CA'
      // },
      // {
      //   label: t`USA`,
      //   value: 'US'
      // },
    ].toSorted((a, b) => a.label.localeCompare(b.label))
  }, [t])
}
